import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { t } from 'i18next';
import { useBlocker } from '@tanstack/react-router';
import LottieAnimations from '@Assets/lottie/Lili_Logo_Loading_Animation.json';
import { useUnifiedKybPolling } from '@Hooks/polling/useUnifiedKybPolling';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';

export const KybPendingPage = () => {
  const elLottieContainer = useRef<HTMLDivElement | null>(null);
  useUnifiedKybPolling();

  useBlocker({
    shouldBlockFn: ({ next }) => {
      const allowedRoutes: string[] = [
        routesModel[RoutesMap.SUCCESS].path,
        routesModel[RoutesMap.SUCCESS_WITHOUT_AUTO_LOGIN].path,
        routesModel[RoutesMap.KYC_FAILED].path,
        routesModel[RoutesMap.VERIFICATION_CENTER].path,
        routesModel[RoutesMap.UNDER_REVIEW].path,
      ];
      return !allowedRoutes.includes(next.routeId);
    },
  });
  useEffect(() => {
    if (elLottieContainer.current) {
      lottie.loadAnimation({
        container: elLottieContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: LottieAnimations,
      });
    }
    return () => lottie.destroy();
  }, [elLottieContainer]);

  return (
    <div className='flex min-h-full w-full items-center justify-center bg-surface-primary-bw-03 px-[24px] tablet:px-0'>
      <div className='flex max-w-[400px] h-[513px] flex-col rounded-[20px] bg-surface-primary-bw-00 w-full tablet:max-w-[630px] tablet:max-h-[513px] tablet:px-[60px] px-[24px] tablet:py-[40px]'>
        <div className='flex flex-col gap-[14px] justify-center items-center h-full'>
          <div className='w-[93px] h-[93px]' ref={elLottieContainer}></div>

          <div className='flex flex-col gap-[16px] justify-center items-center'>
            <Heading.H5 fontWeight={FontWeight.SEMIBOLD} className='text-center'>
              {t('pages.KYB_POLLING.title')}
            </Heading.H5>

            <Text.H9>{t('pages.KYB_POLLING.content')}</Text.H9>
          </div>
        </div>
      </div>
    </div>
  );
};
